export const state = {
    "categoryType": "STATES",
    "categoryData": [
        {
            "ID": 1,
            "VALUE": "Andaman and Nicobar Island",
            "NAME": "Andaman_and_Nicobar_Island"
        },
        {
            "ID": 2,
            "VALUE": "Andhra Pradesh",
            "NAME": "Andhra_Pradesh"
        },
        {
            "ID": 3,
            "VALUE": "Arunachal Pradesh",
            "NAME": "Arunachal_Pradesh"
        },
        {
            "ID": 4,
            "VALUE": "Assam",
            "NAME": "Assam"
        },
        {
            "ID": 5,
            "VALUE": "Bihar",
            "NAME": "Bihar"
        },
        {
            "ID": 6,
            "VALUE": "Chandigarh",
            "NAME": "Chandigarh"
        },
        {
            "ID": 7,
            "VALUE": "Chhattisgarh",
            "NAME": "Chhattisgarh"
        },
        {
            "ID": 8,
            "VALUE": "Dadra and Nagar Haveli",
            "NAME": "Dadra_and_Nagar_Haveli"
        },
        {
            "ID": 9,
            "VALUE": "Daman and Diu",
            "NAME": "Daman_and_Diu"
        },
        {
            "ID": 10,
            "VALUE": "Delhi",
            "NAME": "Delhi"
        },
        {
            "ID": 11,
            "VALUE": "Goa",
            "NAME": "Goa"
        },
        {
            "ID": 12,
            "VALUE": "Gujarat",
            "NAME": "Gujarat"
        },
        {
            "ID": 13,
            "VALUE": "Haryana",
            "NAME": "Haryana"
        },
        {
            "ID": 14,
            "VALUE": "Himachal Pradesh",
            "NAME": "Himachal_Pradesh"
        },
        {
            "ID": 15,
            "VALUE": "Jammu and Kashmir",
            "NAME": "Jammu_and_Kashmir"
        },
        {
            "ID": 16,
            "VALUE": "Jharkhand",
            "NAME": "Jharkhand"
        },
        {
            "ID": 17,
            "VALUE": "Karnataka",
            "NAME": "Karnataka"
        },
        {
            "ID": 18,
            "VALUE": "Kerala",
            "NAME": "Kerala"
        },
        {
            "ID": 19,
            "VALUE": "Lakshadweep",
            "NAME": "Lakshadweep"
        },
        {
            "ID": 20,
            "VALUE": "Madhya Pradesh",
            "NAME": "Madhya_Pradesh"
        },
        {
            "ID": 21,
            "VALUE": "Maharashtra",
            "NAME": "Maharashtra"
        },
        {
            "ID": 22,
            "VALUE": "Manipur",
            "NAME": "Manipur"
        },
        {
            "ID": 23,
            "VALUE": "Meghalaya",
            "NAME": "Meghalaya"
        },
        {
            "ID": 24,
            "VALUE": "Mizoram",
            "NAME": "Mizoram"
        },
        {
            "ID": 25,
            "VALUE": "Nagaland",
            "NAME": "Nagaland"
        },
        {
            "ID": 26,
            "VALUE": "Odisha",
            "NAME": "Odisha"
        },
        {
            "ID": 27,
            "VALUE": "Puducherry",
            "NAME": "Puducherry"
        },
        {
            "ID": 28,
            "VALUE": "Punjab",
            "NAME": "Punjab"
        },
        {
            "ID": 29,
            "VALUE": "Rajasthan",
            "NAME": "Rajasthan"
        },
        {
            "ID": 30,
            "VALUE": "Sikkim",
            "NAME": "Sikkim"
        },
        {
            "ID": 31,
            "VALUE": "Tamil Nadu",
            "NAME": "Tamil_Nadu"
        },
        {
            "ID": 32,
            "VALUE": "Telangana",
            "NAME": "Telangana"
        },
        {
            "ID": 33,
            "VALUE": "Tripura",
            "NAME": "Tripura"
        },
        {
            "ID": 34,
            "VALUE": "Uttar Pradesh",
            "NAME": "Uttar_Pradesh"
        },
        {
            "ID": 35,
            "VALUE": "Uttarakhand",
            "NAME": "Uttarakhand"
        },
        {
            "ID": 36,
            "VALUE": "West Bengal",
            "NAME": "West_Bengal"
        },
        {
            "ID": 37,
            "VALUE": "Other",
            "NAME": "Other"
        }
    ]
}

export const city = {
    "categoryType": "CITIES",
    "categoryData": [
        {
            "ID": 1,
            "VALUE": "Guntur",
            "NAME": "Guntur",
            "STATE_ID": 2
        },
        {
            "ID": 2,
            "VALUE": "Vijayawada",
            "NAME": "Vijayawada",
            "STATE_ID": 2
        },
        {
            "ID": 3,
            "VALUE": "Vishapatnam",
            "NAME": "Vishapatnam",
            "STATE_ID": 2
        },
        {
            "ID": 4,
            "VALUE": "Guwahati",
            "NAME": "Guwahati",
            "STATE_ID": 4
        },
        {
            "ID": 5,
            "VALUE": "Patna",
            "NAME": "Patna",
            "STATE_ID": 5
        },
        {
            "ID": 6,
            "VALUE": "Chandigarh",
            "NAME": "Chandigarh",
            "STATE_ID": 7
        },
        {
            "ID": 7,
            "VALUE": "Delhi",
            "NAME": "Delhi",
            "STATE_ID": 10
        },
        {
            "ID": 8,
            "VALUE": "Jamnagar",
            "NAME": "Jamnagar",
            "STATE_ID": 12
        },
        {
            "ID": 9,
            "VALUE": "Rajkot",
            "NAME": "Rajkot",
            "STATE_ID": 12
        },
        {
            "ID": 10,
            "VALUE": "Surat",
            "NAME": "Surat",
            "STATE_ID": 12
        },
        {
            "ID": 11,
            "VALUE": "Vadodara",
            "NAME": "Vadodara",
            "STATE_ID": 12
        },
        {
            "ID": 12,
            "VALUE": "Faridabad",
            "NAME": "Faridabad",
            "STATE_ID": 13
        },
        {
            "ID": 13,
            "VALUE": "Gurugram",
            "NAME": "Gurugram",
            "STATE_ID": 13
        },
        {
            "ID": 14,
            "VALUE": "Srinagar",
            "NAME": "Srinagar",
            "STATE_ID": 15
        },
        {
            "ID": 15,
            "VALUE": "Jammu",
            "NAME": "Jammu",
            "STATE_ID": 15
        },
        {
            "ID": 16,
            "VALUE": "Dhanbad",
            "NAME": "Dhanbad",
            "STATE_ID": 16
        },
        {
            "ID": 17,
            "VALUE": "Jamshedpur",
            "NAME": "Jamshedpur",
            "STATE_ID": 16
        },
        {
            "ID": 18,
            "VALUE": "Ranchi",
            "NAME": "Ranchi",
            "STATE_ID": 16
        },
        {
            "ID": 19,
            "VALUE": "Belgaum",
            "NAME": "Belgaum",
            "STATE_ID": 17
        },
        {
            "ID": 20,
            "VALUE": "Bengaluru",
            "NAME": "Bengaluru",
            "STATE_ID": 17
        },
        {
            "ID": 21,
            "VALUE": "Mangalore",
            "NAME": "Mangalore",
            "STATE_ID": 17
        },
        {
            "ID": 22,
            "VALUE": "Mysore",
            "NAME": "Mysore",
            "STATE_ID": 17
        },
        {
            "ID": 23,
            "VALUE": "Kochi",
            "NAME": "Kochi",
            "STATE_ID": 18
        },
        {
            "ID": 24,
            "VALUE": "Kozhikode",
            "NAME": "Kozhikode",
            "STATE_ID": 18
        },
        {
            "ID": 25,
            "VALUE": "Thiruvanathpuram",
            "NAME": "Thiruvanathpuram",
            "STATE_ID": 18
        },
        {
            "ID": 26,
            "VALUE": "Bhopal",
            "NAME": "Bhopal",
            "STATE_ID": 20
        },
        {
            "ID": 27,
            "VALUE": "Gwalior",
            "NAME": "Gwalior",
            "STATE_ID": 20
        },
        {
            "ID": 28,
            "VALUE": "Indore",
            "NAME": "Indore",
            "STATE_ID": 20
        },
        {
            "ID": 29,
            "VALUE": "Jabalpur",
            "NAME": "Jabalpur",
            "STATE_ID": 20
        },
        {
            "ID": 30,
            "VALUE": "Amravati",
            "NAME": "Amravati",
            "STATE_ID": 21
        },
        {
            "ID": 31,
            "VALUE": "Aurangabad",
            "NAME": "Aurangabad",
            "STATE_ID": 21
        },
        {
            "ID": 32,
            "VALUE": "Bhiwandi",
            "NAME": "Bhiwandi",
            "STATE_ID": 21
        },
        {
            "ID": 33,
            "VALUE": "Kolhapur",
            "NAME": "Kolhapur",
            "STATE_ID": 21
        },
        {
            "ID": 34,
            "VALUE": "Mumbai",
            "NAME": "Mumbai",
            "STATE_ID": 21
        },
        {
            "ID": 35,
            "VALUE": "Nagpur",
            "NAME": "Nagpur",
            "STATE_ID": 21
        },
        {
            "ID": 36,
            "VALUE": "Nashik",
            "NAME": "Nashik",
            "STATE_ID": 21
        },
        {
            "ID": 37,
            "VALUE": "Pune",
            "NAME": "Pune",
            "STATE_ID": 21
        },
        {
            "ID": 38,
            "VALUE": "Solapur",
            "NAME": "Solapur",
            "STATE_ID": 21
        },
        {
            "ID": 39,
            "VALUE": "Cuttack",
            "NAME": "Cuttack",
            "STATE_ID": 26
        },
        {
            "ID": 40,
            "VALUE": "Amritsar",
            "NAME": "Amritsar",
            "STATE_ID": 28
        },
        {
            "ID": 41,
            "VALUE": "Jalandhar",
            "NAME": "Jalandhar",
            "STATE_ID": 28
        },
        {
            "ID": 42,
            "VALUE": "Ludhina",
            "NAME": "Ludhina",
            "STATE_ID": 28
        },
        {
            "ID": 43,
            "VALUE": "Bikaner",
            "NAME": "Bikaner",
            "STATE_ID": 29
        },
        {
            "ID": 44,
            "VALUE": "Jaipur",
            "NAME": "Jaipur",
            "STATE_ID": 29
        },
        {
            "ID": 45,
            "VALUE": "Jodhpur",
            "NAME": "Jodhpur",
            "STATE_ID": 29
        },
        {
            "ID": 46,
            "VALUE": "Kota",
            "NAME": "Kota",
            "STATE_ID": 29
        },
        {
            "ID": 47,
            "VALUE": "Chennai",
            "NAME": "Chennai",
            "STATE_ID": 31
        },
        {
            "ID": 48,
            "VALUE": "Coimbatore",
            "NAME": "Coimbatore",
            "STATE_ID": 31
        },
        {
            "ID": 49,
            "VALUE": "Madurai",
            "NAME": "Madurai",
            "STATE_ID": 31
        },
        {
            "ID": 50,
            "VALUE": "Salem",
            "NAME": "Salem",
            "STATE_ID": 31
        },
        {
            "ID": 51,
            "VALUE": "Tiruchirappalli",
            "NAME": "Tiruchirappalli",
            "STATE_ID": 31
        },
        {
            "ID": 52,
            "VALUE": "Tiruppur",
            "NAME": "Tiruppur",
            "STATE_ID": 31
        },
        {
            "ID": 53,
            "VALUE": "Hyderabad",
            "NAME": "Hyderabad",
            "STATE_ID": 32
        },
        {
            "ID": 54,
            "VALUE": "Warangal",
            "NAME": "Warangal",
            "STATE_ID": 32
        },
        {
            "ID": 55,
            "VALUE": "Agra",
            "NAME": "Agra",
            "STATE_ID": 34
        },
        {
            "ID": 56,
            "VALUE": "Aligarh",
            "NAME": "Aligarh",
            "STATE_ID": 34
        },
        {
            "ID": 57,
            "VALUE": "Allahabad",
            "NAME": "Allahabad",
            "STATE_ID": 34
        },
        {
            "ID": 58,
            "VALUE": "Bareilly",
            "NAME": "Bareilly",
            "STATE_ID": 34
        },
        {
            "ID": 59,
            "VALUE": "Ghaziabad",
            "NAME": "Ghaziabad",
            "STATE_ID": 34
        },
        {
            "ID": 60,
            "VALUE": "Gorakhpur",
            "NAME": "Gorakhpur",
            "STATE_ID": 34
        },
        {
            "ID": 61,
            "VALUE": "Kanpur",
            "NAME": "Kanpur",
            "STATE_ID": 34
        },
        {
            "ID": 62,
            "VALUE": "Lucknow",
            "NAME": "Lucknow",
            "STATE_ID": 34
        },
        {
            "ID": 63,
            "VALUE": "Meerut",
            "NAME": "Meerut",
            "STATE_ID": 34
        },
        {
            "ID": 64,
            "VALUE": "Moradabad",
            "NAME": "Moradabad",
            "STATE_ID": 34
        },
        {
            "ID": 65,
            "VALUE": "Noida",
            "NAME": "Noida",
            "STATE_ID": 34
        },
        {
            "ID": 66,
            "VALUE": "Varanasi",
            "NAME": "Varanasi",
            "STATE_ID": 34
        },
        {
            "ID": 73,
            "VALUE": "Pondicherry",
            "NAME": "Pondicherry",
            "STATE_ID": 37
        },
        {
            "ID": 74,
            "VALUE": "Other",
            "NAME": "Other",
            "STATE_ID": 37
        },
        {
            "ID": 69,
            "VALUE": "Dehradun",
            "NAME": "Dehradun",
            "STATE_ID": 35
        },
        {
            "ID": 70,
            "VALUE": "Kolkata",
            "NAME": "Kolkata",
            "STATE_ID": 36
        },
        {
            "ID": 71,
            "VALUE": "Asansol",
            "NAME": "Asansol",
            "STATE_ID": 36
        },
        {
            "ID": 72,
            "VALUE": "Hubli-Dhanbad",
            "NAME": "Hubli-Dhanbad",
            "STATE_ID": 37
        }
    ]
}



